import { useEffect, useState } from "react";
import React from "react";
import axios from "axios";
import TableOne from "../Table/TableOne"; // Import your table component
import Modal from "react-modal";
import "./../style/modal.css";
import "./../style/common.css";
import "./../style/pop-up.css";
import { TextField, MenuItem } from "@mui/material";
import { InputAdornment } from "@mui/material";
import { MdGroups } from "react-icons/md";
import { FaUser } from "react-icons/fa";
import { ToastContainer, toast } from "react-toastify";
import { CiWarning } from "react-icons/ci";
import { Multiselect } from "multiselect-react-dropdown";

const SubTeam = () => {
  const [subteam, setSubTeam] = useState([]);
  const [team, setTeam] = useState([]); //team
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [employee, setEmployees] = useState([]); //emp
  const [filteredSubteam, setFilteredSubteams] = useState([]); // For search functionality
  const [errors, setErrors] = useState({}); //error show state
  const [formData, setFormData] = useState({
    subteam_teammaster_id: "", //FK Team Master
    subteam_employee_ids: [], //FK Employee_Master
  });

  // State to manage delete subteam details
  const [deleteSubTeamName, setDeleteSubTeamName] = useState("");
  const [deleteSubTeamId, setDeleteSubTeamId] = useState(null);
  const [showDeleteSubTeamBox, setShowDeleteSubTeamBox] = useState(false);
  const [editMode, setEditMode] = useState(false); // Edit mode flag

  //featch SubTeam data from the API
  const fetchSubTeams = async () => {
    setLoading(true);
    try {
      // Fetch the teams
      const response = await axios.get(
        "https://aligndesk.dropyourbusiness.com/api/subteams"
      );
      const subteamData = response.data.subteam.map((st) => ({
        SubTeamId: st.subteam_id,
        SubTeamMasterId: st.subteam_teammaster_id,
        SubTeamEmployeeId: st.subteam_employee_id,
      }));
      // Fetch employee data
      const employeeResponse = await axios.get(
        "https://aligndesk.dropyourbusiness.com/api/emp"
      );
      const employeeData = employeeResponse.data.employees;
      // Fetch team data
      const teamResponse = await axios.get(
        "https://aligndesk.dropyourbusiness.com/api/teams"
      );
      const teamData = teamResponse.data.team.map((t) => ({
        TeamId: t.team_id,
        TeamName: t.team_name,
      }));
      // Map subteam data with team and employee details
      const subteamDataWithDetails = subteamData.map((subteam) => {
        // Find the corresponding employee
        const employee = employeeData.find(
          (emp) => emp.employee_id === subteam.SubTeamEmployeeId
        );
        // Find the corresponding team
        const teamDetail = teamData.find(
          (team) => team.TeamId === subteam.SubTeamMasterId
        );
        // Return enriched subteam data
        return {
          ...subteam,
          EmployeeName: employee
            ? `${employee.employee_first_name} ${employee.employee_last_name}`
            : "Unknown Employee",
          TeamName: teamDetail ? teamDetail.TeamName : "Unknown Team",
        };
      });
      console.log("Subteam Data->>", subteamData);
      // Update tasks state with the enriched data
      setSubTeam(subteamDataWithDetails);
      setFilteredSubteams(subteamDataWithDetails); // Initialize filtered data
    } catch (error) {
      console.error("Error Fetching SubTeam", error);
    }
    setLoading(false);
  };
  useEffect(() => {
    fetchSubTeams();
  }, []);

  // Fetch employees data from the API
  const fetchEmployees = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        "https://aligndesk.dropyourbusiness.com/api/emp"
      );
      console.log(response);
      const employeeData = response.data.employees
        .filter((emp) => emp.employee_role === "E") // Filter only employees with role "E"
        .map((emp) => ({
          Employee_id: emp.employee_id,
          EmployeeName: `${emp.employee_first_name} ${emp.employee_last_name}`, // Full name
        }));
      console.log("Filtered employees:", employeeData);
      setEmployees(employeeData);
    } catch (error) {
      console.error("Error fetching employee data:", error);
    }
    setLoading(false);
  };
  useEffect(() => {
    fetchEmployees();
  }, []);

  //featch Team data from the API
  const fetchTeams = async () => {
    setLoading(true);
    try {
      // Fetch the teams
      const response = await axios.get(
        "https://aligndesk.dropyourbusiness.com/api/teams"
      );
      console.log(response);
      const teamData = response.data.team.map((t) => ({
        TeamId: t.team_id,
        TeamProjectID: t.team_project_id,
        TemEmpId: t.team_employee_id,
        TeamName: t.team_name,
        TeamIsActive: t.team_isactive,
      }));
      setTeam(teamData);
      console.log("Team Data->>", teamData);
    } catch (error) {
      console.error("Error fetching employee data:", error);
    }
    setLoading(false);
  };
  useEffect(() => {
    fetchTeams();
  }, []);

  //edit
  const handleEdit = (st) => {
    console.log("Opening Edit Modal for:", st);

    // Find the selected employees based on their IDs
    const selectedEmployees = employee.filter((emp) =>
      Array.isArray(st.SubTeamEmployeeId)
        ? st.SubTeamEmployeeId.includes(emp.Employee_id)
        : emp.Employee_id === st.SubTeamEmployeeId
    );

    setFormData({
      subteam_id: st.SubTeamId,
      subteam_teammaster_id: st.SubTeamMasterId,
      subteam_employee_ids: selectedEmployees.map((emp) => emp.Employee_id), // Store only IDs
    });

    setEditMode(true);
    setIsModalOpen(true);
  };
  // Handle delete action
  const handleDelete = async (subteamData) => {
    const subteam_id = subteamData.SubTeamId;
    const subteam_name = subteamData.TeamName || "Unnamed SubTeam"; // Replace with actual subteam name field
    if (!subteam_id) {
      toast.error("Invalid subteam ID. Please try again.");
      return;
    }
    // Set the subteam name and ID to state before showing the pop-up
    setDeleteSubTeamName(subteam_name);
    setDeleteSubTeamId(subteam_id);
    setShowDeleteSubTeamBox(true); // Show the custom confirmation box
  };

  // Confirm delete function
  const confirmDeleteSubTeam = async () => {
    if (!deleteSubTeamId) return;
    try {
      const response = await axios.delete(
        `https://aligndesk.dropyourbusiness.com/api/subteam/delete/${deleteSubTeamId}`
      );
      if (response.status === 200) {
        toast.success("SubTeam deleted successfully!");
        const updatedSubTeams = subteam.filter(
          (item) => item.SubTeamId !== deleteSubTeamId
        );
        setSubTeam(updatedSubTeams); // Update the subteams state after deletion
        setFilteredSubteams(updatedSubTeams); // Update the filtered subteams list
      }
      setShowDeleteSubTeamBox(false); // Close the confirmation box
    } catch (error) {
      console.error("Error deleting SubTeam:", error);
      toast.error("An error occurred while deleting the SubTeam.");
      setShowDeleteSubTeamBox(false); // Close the box on error
    }
  };

  // Cancel delete function
  const cancelDeleteSubTeam = () => {
    setShowDeleteSubTeamBox(false); // Close the confirmation box
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const openModal = (subteamData = null) => {
    if (subteamData) {
      setFormData({
        subteam_id: subteamData.SubTeamId || "",
        subteam_teammaster_id: subteamData.SubTeamMasterId || "",
        subteam_employee_ids: Array.isArray(subteamData.SubTeamEmployeeId)
          ? subteamData.SubTeamEmployeeId
          : [subteamData.SubTeamEmployeeId], //Ensure it's always an array
      });
      setEditMode(true);
    } else {
      setFormData({
        subteam_id: "",
        subteam_teammaster_id: "",
        subteam_employee_ids: [], //Corrected to an empty array
      });
      setEditMode(false);
    }
    setIsModalOpen(true);
    setErrors({});
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  //multiselectField
  const handleMultiselectChange = (selectedList) => {
    setFormData({
      ...formData,
      subteam_employee_ids: selectedList.map((item) => item.Employee_id), // Store array of employee IDs
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Validation function
    const validateForm = () => {
      const newErrors = {};
      if (!formData.subteam_teammaster_id) {
        newErrors.subteam_teammaster_id = "Team name is required.";
      }
      if (
        !formData.subteam_employee_ids ||
        formData.subteam_employee_ids.length === 0
      ) {
        newErrors.subteam_employee_ids = "At least one employee is required.";
      }
      return newErrors;
    };
    const errors = validateForm();
    if (Object.keys(errors).length > 0) {
      setErrors(errors);
      return;
    }
    // Proceed with API request if no errors
    try {
      let url, method, requestData;
      if (editMode) {
        url = "https://aligndesk.dropyourbusiness.com/api/change-employee-team";
        method = "PUT";
        const employeeId =
          Array.isArray(formData.subteam_employee_ids) &&
          formData.subteam_employee_ids.length > 0
            ? Number(formData.subteam_employee_ids[0])
            : null;
        if (!employeeId) {
          toast.error("At least one employee must be selected!");
          return;
        }
        requestData = {
          subteam_employee_id: employeeId,
          new_subteam_teammaster_id: Number(formData.subteam_teammaster_id),
        };
      } else {
        url =
          "https://aligndesk.dropyourbusiness.com/api/add-multiple-subteams";
        method = "POST";
        requestData = {
          subteam_teammaster_id: Number(formData.subteam_teammaster_id),
          subteam_employee_ids: formData.subteam_employee_ids.map(Number),
        };
      }

      const response = await axios({
        method,
        url,
        data: requestData,
      });

      toast.success(
        editMode
          ? "SubTeam updated successfully!"
          : "SubTeam added successfully!"
      );

      fetchSubTeams(); // Refresh data
      closeModal();
      setErrors({});
    } catch (error) {
      console.error("Error submitting data:", error.response?.data);
      toast.error(
        error.response?.data?.message ||
          "An error occurred while submitting data."
      );
    }
  };

  //Table columns
  const columns = [
    { Header: "Sr.No", accessor: (row, index) => index + 1, id: "index" },
    {
      Header: "Team",
      // accessor: "SubTeamMasterId",
      accessor: "TeamName", // Use TeamName here
      Cell: ({ value }) => (value ? value.toLocaleString() : "N/A"),
    },
    {
      Header: "Employee",
      // accessor: "SubTeamEmployeeId",
      accessor: "EmployeeName", // Use EmployeeName here
      Cell: ({ value }) => (value ? value.toLocaleString() : "N/A"),
    },
  ];

  return (
    <div>
      <ToastContainer />
      <div
        className="page-head"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          fontSize: "10px",
          marginLeft: "1%",
          marginRight: "2%",
        }}
      >
        <h1>
          <MdGroups /> Team Member
        </h1>
        <button className="add-button" onClick={() => openModal()}>
          + Add
        </button>
      </div>

      {loading ? (
        <div className="loader-container">
          <div className="loader"></div>
          <p>Loading...</p>
        </div>
      ) : (
        <TableOne
          columns={columns}
          data={filteredSubteam.slice().reverse()}
          handleEdit={handleEdit}
          handleDelete={handleDelete}
          isDeleteAction={true}
          isEditAction={true}
        />
      )}

      {showDeleteSubTeamBox && (
        <div className="popup-overlay">
          <div className="popup-box">
            <div className="popup-header">
              <CiWarning /> Confirm Delete
            </div>
            <div className="popup-message">
              Are you sure you want to delete the subteam{" "}
              <span className="subteam-name">
                <strong>{deleteSubTeamName}</strong>
              </span>{" "}
              from the system?
            </div>
            <div className="popup-buttons">
              <button className="confirm-button" onClick={confirmDeleteSubTeam}>
                Yes, Delete
              </button>
              <button className="cancel-button" onClick={cancelDeleteSubTeam}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      <Modal
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        contentLabel="Team Form"
        className="add-team-modal"
        shouldCloseOnOverlayClick={false} //other click on screen, never close form modal
        style={{
          content: {
            width: "450px",
          },
        }}
      >
        <h2>{editMode ? "Edit Team Member" : "Add Team Member"}</h2>
        <form className="team-form" onSubmit={handleSubmit}>
          <div className="form-container">
            {/* Row 1 */}
            <div className="form-row-team">
              <div className="form-field">
                <TextField
                  select
                  label="Team"
                  name="subteam_teammaster_id"
                  value={formData.subteam_teammaster_id}
                  error={!!errors.subteam_teammaster_id}
                  helperText={errors.subteam_teammaster_id}
                  onChange={handleInputChange}
                  fullWidth
                  style={{ width: "450px" }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment
                        position="start"
                        style={{ color: "black" }}
                      >
                        <MdGroups />
                      </InputAdornment>
                    ),
                  }}
                >
                  <MenuItem value="">Select Team</MenuItem>
                  {team.map((teamData) => (
                    <MenuItem
                      key={teamData.TeamId}
                      value={teamData.TeamId} // Use team ID for submission
                    >
                      {teamData.TeamName}
                    </MenuItem>
                  ))}
                </TextField>
              </div>
            </div>
            {/* Row 2 */}
            <div className="form-row">
              <div className="form-field">
                {/* Select Multiple Employee */}
                <Multiselect
                  options={employee || []} // Options for the dropdown
                  selectedValues={employee.filter((item) =>
                    formData.subteam_employee_ids.includes(item.Employee_id)
                  )} // The selected values based on the `team_employee_id` array
                  displayValue="EmployeeName" // Value to display in the dropdown
                  onSelect={handleMultiselectChange} // When the user selects an item
                  onRemove={handleMultiselectChange} // When the user removes an item
                  showCheckbox={true} // Show checkboxes
                  value={formData.subteam_employee_ids}
                  error={!!errors.team_employee_id}
                  placeholder="Select Employee"
                  avoidHighlightFirstOption={true}
                  fullWidth
                  style={{
                    width: "450px",
                    multiselectContainer: { width: "100%" }, // Full width container
                    chips: { background: "#007bff", color: "#fff" }, // Styling for selected items
                    searchBox: { minHeight: "40px", fontSize: "14px" }, // Input box styling
                    optionContainer: { fontSize: "14px" }, // Dropdown styling
                    option: { backgroundColor: "transparent", color: "#000" }, // Remove blue hover
                    highlightOption: { backgroundColor: "transparent" }, // Prevent blue highlight
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment
                        position="start"
                        style={{ color: "black" }}
                      >
                        <FaUser />
                      </InputAdornment>
                    ),
                  }}
                />
                {/* Display validation error below the Multiselect */}
                {errors.subteam_employee_ids && (
                  <p
                    style={{ color: "red", fontSize: "12px", marginTop: "5px" }}
                  >
                    {errors.subteam_employee_ids}
                  </p>
                )}
              </div>
            </div>
            <div className="form-actions">
              <button variant="contained" color="primary" type="submit">
                {editMode ? "Edit" : "+Add"}
              </button>
              <button
                variant="outlined"
                onClick={closeModal}
                className="close-button"
              >
                Cancel
              </button>
            </div>
          </div>
        </form>
      </Modal>
    </div>
  );
};
export default SubTeam;
